import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { msUrlServer, urlServer } from '../global_constants';
import { Referential } from '../models/referential';
import { ServiceResponse } from '../models/service-response';
import { Sector } from '../models/ms_sector';

@Injectable({
  providedIn: 'root'
})
export class SectorService {

  baseUrl = urlServer.concat("/v1/ref/sectors");
  sectorUrl = urlServer.concat("/v1/sector");

  public get token() : string|null {
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
    return localStorage.getItem("token");
    return sessionStorage.getItem("token");   
  }
  constructor(private httpClient:HttpClient) { }

  deleteSector(uuid: string){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.httpClient.delete<ServiceResponse>(`${this.sectorUrl}/${uuid}`,{headers: header});
  }

  getSectorsIndicators(){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.httpClient.get<ServiceResponse>(`${this.baseUrl}/customers`,{headers: header});
  }

  // getSectors(){
  //   let header: HttpHeaders = new HttpHeaders();
  //   header = header.set('authorization', "Bearer " + this.token);
  //   return this.httpClient.get<ServiceResponse>(this.sectorUrl, {headers: header});
  // }

  // addSector(sector: Sector){
  //   let header: HttpHeaders = new HttpHeaders();
  //   header = header.set('authorization', "Bearer " + this.token);
  //   return this.httpClient.post<ServiceResponse>(this.sectorUrl, sector, {headers: header});
  // }

  // updateSector(sector: Referential){
  //   let header: HttpHeaders = new HttpHeaders();
  //   header = header.set('authorization', "Bearer " + this.token);
  //   return this.httpClient.put<ServiceResponse>(this.sectorUrl, sector, {headers: header});
  // }


}
 